<template>
  <div class="form-group with-icon-right dropdown select-form-group"
       v-dropdown="{closeOnMenuClick: true, noToggle: search, prevent: !search, disabled: readonly}"
       :class="{'has-error': hasErrors()}"
       ref="dropdownContainer"
       @dropdownToggle="show => show ? inputValue = '' : updateDisplayValue(value)">
    <div class="input-group dropdown-toggle">
      <input
        :placeholder="placeholder"
        :readonly="readonly || !search"
        :class="{'has-value': !!inputValue, 'no-value': !inputValue, search, 'read-write': !readonly}"
        v-model="inputValue"
        :name="name"
      />
      <i class="ion ion-ios-arrow-down icon-right input-icon" v-if="!readonly"></i>
      <label class="control-label">{{label}}</label><i class="bar"></i>
      <small v-show="hasErrors()" class="help text-danger">{{ showRequiredError() }}</small>
    </div>
    <slot name="icon"></slot>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <scrollbar ref="scrollbar">
        <div class="dropdown-menu-content">
          <div class="dropdown-item"
               :class="{'selected': isOptionSelected(option)}" v-for="option in options"
               @click="selectOption(option)">
            <slot :value="option"><span class="ellipsis">{{renderOptionDisplay(option)}}</span></slot>
          </div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
  import Dropdown from 'vuestic-directives/Dropdown';
  import Scrollbar from '../vuestic-scrollbar/VuesticScrollbar.vue';

  export default {
    name: 'vuestic-simple-select',
    components: {
      Scrollbar,
    },
    directives: {
      dropdown: Dropdown,
    },
    data () {
      return {
        inputValue: '',
        validated: false,
      };
    },
    props: {
      label: String,
      options: Array,
      value: {},
      optionKey: String,
      required: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: 'simple-select',
      },
      search: Boolean,
      displayValue: Function,
      placeholder: String,
      readonly: Boolean,
    },
    mounted () {
      this.updateDisplayValue(this.value);
      // this.$emit('input', this.value);
    },

    // updated: function () {
    //   this.updateDisplayValue(this.value)
    // },

    watch: {
      inputValue () {
        if (this.$refs.dropdownContainer && this.$refs.dropdownContainer.classList.contains('show')) {
          this.$emit('search', this.inputValue);
        }
      },
      value (v) {
        this.updateDisplayValue(v);
      },
      options () {
        setTimeout(() => {
          this.$refs.scrollbar && this.$refs.scrollbar.onContentResize();
        });
      },
    },

    methods: {
      isOptionSelected (option) {
        return this.value === option;
      },
      selectOption (option) {
        this.$emit('input', option);
      },
      updateDisplayValue (val) {
        if (this.search && this.$refs.dropdownContainer && this.$refs.dropdownContainer.classList.contains('show')) {
          return;
        }
        this.inputValue = this.renderOptionDisplay(val);
      },
      renderOptionDisplay (val) {
        return this.displayValue
          ? this.displayValue(val)
          : val == null
            ? ''
            : this.optionKey
              ? val[this.optionKey]
              : val;
      },
      validate () {
        this.validated = true;
      },
      isValid () {
        let isValid = true;
        if (this.required) {
          isValid = !!this.inputValue;
        }
        return isValid;
      },
      hasErrors () {
        let hasErrors = false;
        if (this.required) {
          hasErrors = this.validated && !this.inputValue;
        }
        return hasErrors;
      },
      showRequiredError () {
        return `The ${this.name} field is required`;
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/variables";

  $mf-border-color : #999 !default;
  $mf-label-color : lighten($mf-border-color, 10%) !default;
  $mf-transition-speed : 0.28s !default;

  .select-form-group {
    .dropdown-toggle {
      input:not(.search) {
        color       : transparent;
        text-shadow : 0 0 0 #000;
        &.read-write {
          cursor : pointer;
        }
        @media print {
          color : inherit !important;
        }
      }
      input.search::placeholder {
        color      : transparent;
        transition : all $mf-transition-speed ease;
      }
      input.search:focus::placeholder {
        color : $mf-label-color;
      }
    }
    .dropdown-menu {
      padding : 0;
      .vuestic-scrollbar {
        height : $dropdown-item-height * 4;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue